module.exports = __webpack_public_path__ + "static/media/main_visual_compact_track_loaders_2150_rt_manitou.bfcd1792.png";